import React from "react";
import PropTypes from "prop-types";
import IconTile from "../IconTile";

// A grid (or list) of icon tiles
export const Generator = ({ entity, isHorizontal }) => (
  <div className={isHorizontal ? "icon-list icon-list-view" : "icon-list"}>
    {entity.map((icon) => (
      <IconTile key={icon.id} entity={icon} />
    ))}
  </div>
);

Generator.propTypes = {
  entity: PropTypes.array.isRequired,
  isHorizontal: PropTypes.bool,
};

export default Generator;
